import apiClient from "./middleware";

export type PlaylistPrivacyStatus = "private" | "unlisted" | "public";

export interface OacPlaylistPreviewVideo {
  videoId: string;
  title: string;
  publishedAt?: string;
}

export interface OacPlaylistPreviewResponse {
  channelId: string;
  channelTitle: string;
  brandName: string;
  suggestedTitle: string;
  contentOwnerId: string;
  videos: OacPlaylistPreviewVideo[];
}

export interface CreateOacPlaylistRequest {
  channelId: string;
  title?: string;
  description?: string;
  privacyStatus?: PlaylistPrivacyStatus;
  videoIds?: string[];
}

export interface CreateOacPlaylistVideoFailure {
  videoId: string;
  error: string;
}

export interface CreateOacPlaylistResponse {
  playlistId: string;
  playlistUrl: string;
  title: string;
  privacyStatus: PlaylistPrivacyStatus;
  videosAdded: string[];
  failures: CreateOacPlaylistVideoFailure[];
}

function getApiErrorDetail(error: unknown): string {
  if (
    error &&
    typeof error === "object" &&
    "response" in error &&
    error.response &&
    typeof error.response === "object" &&
    "data" in error.response
  ) {
    const data = (error.response as { data?: { error?: string; message?: string } })
      .data;
    if (data?.error) return data.error;
    if (data?.message) return data.message;
  }
  if (error instanceof Error) return error.message;
  return "Unknown error";
}

export const oacPlaylistApi = {
  getPreview: async (channelId: string): Promise<OacPlaylistPreviewResponse> => {
    const response = await apiClient.get<OacPlaylistPreviewResponse>(
      "/oac-playlists/preview",
      { params: { channelId } }
    );
    return response.data;
  },

  create: async (
    body: CreateOacPlaylistRequest
  ): Promise<CreateOacPlaylistResponse> => {
    const response = await apiClient.post<CreateOacPlaylistResponse>(
      "/oac-playlists/create",
      body
    );
    return response.data;
  },

  getApiErrorDetail,
};
